import './entertainment-artist-teaser.scss';

class EntertainmentArtistTeaser {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-entertainmentartistteaser',
            itemValue: 'item',
            toggleValue: 'toggle',
            clampedTargetValue: 'clamped',
            clampActiveAttr: 'data-entertainmentartistteaser-clamped',
            hiddenTeaserAttr: 'data-entertainmentartistteaser-hidden',
            statusAttr: 'data-entertainmentartistteaser-status',
            showAllValue: 'show-all'
        };

        // Merge settings
        this.settings = Object.assign({}, defaults, options);
        this.clampActive = false;

        // DOM Elements
        this.$root = element;
        this.$$items = this.$root.querySelectorAll(`[${this.settings.initAttr}="${this.settings.itemValue}"`);
        this.$showAllButton = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.showAllValue}"]`);
        this.$$hiddenTeasers = this.$root.querySelectorAll(`[${this.settings.hiddenTeaserAttr}]`);
        this.$$toggles = this.$root.querySelectorAll(`[${this.settings.initAttr}="${this.settings.toggleValue}"`);
        this.$status = this.$root.querySelector(`[${this.settings.statusAttr}]`);
        this.windowWidth = window.innerWidth;
    }

    initialize () {
        if (this.$$items.length <= 4) {
            this.observeLineClamp();
        }

        this.setEvents();
    }

    observeLineClamp () {
        const updateLineClamp = ($item, $target) => {
            if ($target.scrollHeight > $target.clientHeight) {
                $item.setAttribute(this.settings.clampActiveAttr, '');
            } else {
                $item.removeAttribute(this.settings.clampActiveAttr);
            }
        };

        this.$$items.forEach($item => {
            const $clampedToggle = $item.querySelector(`[${this.settings.initAttr}="${this.settings.toggleValue}"]`);
            const $clampedTarget = $item.querySelector(`[${this.settings.initAttr}="${this.settings.clampedTargetValue}"]`);

            if ($clampedToggle && $clampedTarget) {
                updateLineClamp($item, $clampedTarget);

                window.resizeHandler.customFunctions.push(() => {
                    if (this.windowWidth !== window.innerWidth) {
                        this.windowWidth = window.innerWidth;
                        $clampedToggle.checked = false;
                        updateLineClamp($item, $clampedTarget);
                    }
                });
            }
        });
    }

    showAll () {
        this.$$hiddenTeasers.forEach($hiddenTeaser => {
            $hiddenTeaser.removeAttribute(this.settings.hiddenTeaserAttr);
        });

        if (this.$status) {
            const info = this.$status.getAttribute(this.settings.statusAttr);
            this.$status.textContent = info;
        }

        this.$showAllButton.parentNode.remove();
    }

    setEvents () {
        if (this.$showAllButton && this.$$hiddenTeasers.length > 0) {
            this.$showAllButton.addEventListener('click', () => {
                this.showAll();
            });
        }

        this.$$toggles.forEach($toggle => {
            $toggle.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    $toggle.checked = !$toggle.checked;
                }
            });
        });
    }
}

export { EntertainmentArtistTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-entertainmentartistteaser="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new EntertainmentArtistTeaser($root);
            $rootAPI.initialize();
        });
    }
});
